export default "__VITE_ASSET__RgNINlSV__"